import { jsonParse, jsonStringify } from 'utils/json';
import { logger } from 'utils/logger';

const STORAGE_KEY = 'telephony_audio_settings';

export const getPersistedAudioSettings = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return { selectedInputDeviceId: null, selectedOutputDeviceId: null };
    }

    return jsonParse(raw);
  } catch (error) {
    logger.warn('[AudioSettings] Failed to read persisted settings', error);

    return { selectedInputDeviceId: null, selectedOutputDeviceId: null };
  }
};

export const persistAudioSettings = updates => {
  try {
    const current = getPersistedAudioSettings();
    const merged = { ...current, ...updates };

    localStorage.setItem(STORAGE_KEY, jsonStringify(merged));
  } catch (error) {
    logger.warn('[AudioSettings] Failed to persist settings', error);
  }
};
